import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, ArrowLeft, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/brand";
import { API, TOKEN_KEY } from "@/lib/api";

export const HistoryLogin = ({ title, backPath, onToken }) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/history/auth`, { password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      onToken(res.data.token);
      toast.success("Accesso effettuato");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Password errata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-buscema-green p-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8 space-y-6">
        <div className="flex flex-col items-center gap-3">
          <img src={LOGO_URL} alt="Buscema" className="w-full max-w-[260px] h-auto" data-testid="login-logo" />
          <div className="flex items-center gap-2 text-buscema-green">
            <Lock className="w-5 h-5" />
            <h1 className="font-heading text-xl font-semibold text-center">{title}</h1>
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-xs font-semibold uppercase tracking-wide text-gray-500">Password Operatore</Label>
          <Input
            data-testid="history-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && password && handleLogin()}
            placeholder="••••••••"
            className="min-h-[56px] rounded-xl text-base"
          />
        </div>
        <Button
          data-testid="history-login-btn"
          onClick={handleLogin}
          disabled={loading || !password}
          className="w-full min-h-[56px] rounded-xl bg-buscema-green hover:bg-buscema-greenDark text-white text-base font-semibold"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Accedi"}
        </Button>
        <button
          onClick={() => navigate(backPath)}
          className="w-full text-sm text-gray-500 hover:text-buscema-green flex items-center justify-center gap-1"
          data-testid="back-to-form-link"
        >
          <ArrowLeft className="w-4 h-4" /> Torna alla scheda
        </button>
      </div>
    </div>
  );
};
